import React from 'react'
import { FormControl, Input, InputLabel } from '@mui/material'
import { FormControlProps } from '@mui/material/FormControl/FormControl'

import Countries from '../../constants/localization/countries'
import i18n from '../../locales/i18n'
import PuiSelect, { PuiSelectProps } from './PuiSelect'

export interface CountrySelectProps extends Omit<PuiSelectProps, 'margin'> {
  readonly hideLabel?: boolean
  readonly margin?: FormControlProps['margin']
}

const CountrySelect = ({
  required,
  field,
  margin = 'normal',
  hideLabel,
  ...rest
}: CountrySelectProps) => (
  <FormControl fullWidth error={field && !field.valid} margin={margin}>
    {!hideLabel && (
      <InputLabel htmlFor="country-select">
        {`${i18n.t('Regions:TERRITORY.COUNTRY')}${required ? '*' : ''}`}
      </InputLabel>
    )}
    <PuiSelect
      field={field}
      input={<Input id="country-select" />}
      items={Countries}
      renderEmpty={false}
      {...rest}
    />
  </FormControl>
)

export default CountrySelect
